import React, { useEffect, useState } from 'react'
import Proptypes from 'prop-types'
import { push } from 'connected-react-router'

import { OrderRoutes, StepOrder } from '@constants/StepOrderEnum'
import { useDispatch } from 'react-redux'
import * as StepActions from '@redux/ui/stepbar/stepbar-action'
import * as OnboardingActions from '@redux/onboarding/onboarding-action'

import ButtonComponent from '@components/button/button'
import { Container, Buttons } from './footer-style'
import { useParams } from 'react-router'
import { ValidationWarning } from './layout-style'

import HttpErrorResponseModel from '@models/http-error-response-model'

const Footer = ({ hasBackButton, currentStep, disableConfirmButton }) => {
  const dispatch = useDispatch()
  const params = useParams()

  const [isLastPage, setIsLastPage] = useState(false)
  const [hasCreateError, setHasCreateError] = useState(false)
  const [error, setError] = useState(false)

  const nextStep = async () => {
    if (currentStep === StepOrder.SecurityStep) {
      setHasCreateError(false)

      const createResponse = await dispatch(OnboardingActions.createCompany())
      var companyId = createResponse.data

      if (companyId) next()

      setHasCreateError(true)
      if (createResponse instanceof HttpErrorResponseModel) {
        setError(createResponse.message)
      } else {
        setError('Ocorreu um erro, tente novamente mais tarde.')
      }

      return
    } else {
      next()
    }
  }

  const redirect = async path => {
    await dispatch(push(path.replace(':planId', params?.planId)))
  }

  const next = async () => {
    await dispatch(StepActions.nextStep())
    await redirect(OrderRoutes[currentStep + 1])
    window.scrollTo(0, 0)
  }

  const backStep = () => {
    dispatch(StepActions.backStep())
    redirect(OrderRoutes[currentStep - 1])
    window.scrollTo(0, 0)
  }

  useEffect(() => {
    if (currentStep === StepOrder.SecurityStep) {
      setIsLastPage(true)
    }
  }, [currentStep])

  return (
    <Container>
      {/* TODO: Separar esse validation warning para um componente mais global ou criar alguma coisa nova */}
      {hasCreateError && <ValidationWarning>{error}</ValidationWarning>}
      <Buttons hasBackButton={!hasBackButton}>
        {hasBackButton && (
          <ButtonComponent theme="secundary" icon="left" onClick={backStep}>
            voltar
          </ButtonComponent>
        )}
        <ButtonComponent disabled={disableConfirmButton} theme="primary" icon="right" onClick={nextStep}>
          {isLastPage ? 'concluir' : 'continuar'}
        </ButtonComponent>
      </Buttons>
    </Container>
  )
}

Footer.propTypes = {
  hasBackButton: Proptypes.bool,
  currentStep: Proptypes.number,
  disableConfirmButton: Proptypes.bool,
}

export default Footer
